export default "__VITE_ASSET__437E$hm9__"